import React from 'react';

interface Props {
  sections: string[];
  selected: string;
  onSelect: (s: string) => void;
}

const AdminSidebar: React.FC<Props> = ({ sections, selected, onSelect }) => {
  const onKey = (e: React.KeyboardEvent, s: string) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onSelect(s);
    }
    // Arrow navigation
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
      e.preventDefault();
      const idx = sections.indexOf(s);
      const next = sections[(idx + 1) % sections.length];
      onSelect(next);
    }
    if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
      e.preventDefault();
      const idx = sections.indexOf(s);
      const prev = sections[(idx - 1 + sections.length) % sections.length];
      onSelect(prev);
    }
  };

  return (
    <nav className="admin-sidebar-nav" aria-label="Seções administrativas" role="tablist">
      {sections.map(s => (
        <button
          key={s}
          role="tab"
          aria-selected={selected === s}
          tabIndex={0}
          className={`admin-sidebar-item ${selected === s ? 'active' : ''}`}
          onClick={() => onSelect(s)}
          onKeyDown={(e) => onKey(e, s)}
        >
          {s}
        </button>
      ))}
    </nav>
  );
};

export default AdminSidebar;
